<mat-card>
      <div class="d-flex align-items-center justify-content-center position-relative">
            <div style="flex: 1; text-align: center;">
                <mat-card-title style="margin: 0;">Asignar Responsable De Bienes</mat-card-title>
            </div>
            <button mat-icon-button color="warn" aria-label="Cerrar" (click)="onButtonClick()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    <mat-card-content *ngIf="!inventoryType">
      <mat-form-field class="col-md-6">
        <mat-label>Seleccione el tipo de bien</mat-label>
        <mat-select [disabled]="inventoryType != undefined" [(ngModel)]="inventoryType" placeholder="Seleccionar">
          <mat-option value=0>Activos Fijos</mat-option>
          <mat-option value=1>Bienes de Control</mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>
    <mat-card-content *ngIf="inventoryType">
      <form class="col-12" [formGroup]="movementAssetsForm" #form="ngForm" (ngSubmit)="save(form)">
  
        <mat-form-field class="col-12 col-md-6">
          <mat-label>Responsable de Activos</mat-label>
          <input matInput formControlName="responsible" readonly style="cursor:pointer;" placeholder="Selecciona el responsable de los activos"
            [required]="true">
          <button mat-icon-button matSuffix type="button" aria-label="Agregar" (click)="selectResponsible()">
            <mat-icon matTooltip="Agregar">playlist_add</mat-icon>
          </button>
          <button mat-icon-button matSuffix type="button" color="warn" aria-label="Cerrar" (click)="removeItem('responsible')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
  
        <mat-form-field appearance="legacy" class="col-12 col-md-6">
          <mat-label>Fecha de entrega</mat-label>
          <input matInput formControlName="deliveryDate" [matDatepicker]="picker" (click)="picker.open()" (keydown)="false" [min]="minimunDate"
          [required]="true" [max]="todayDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <button mat-icon-button matSuffix type="button" color="warn" (click)="removeItem('deliveryDate')">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
  
        <mat-form-field appearance="legacy" class="col-12 col-md-12">
          <mat-label> Observación Entrega</mat-label>
          <input matInput formControlName='observation' [maxLength]="1000">
          <mat-hint align="end">{{movementAssetsForm.get('observation').value ? movementAssetsForm.get('observation').value.length : 0}} /1000</mat-hint>
        </mat-form-field>
  
        <mat-form-field class="col-12 col-md-6">
          <mat-label>Estado</mat-label>
          <mat-select [required]="true" formControlName="state" [(ngModel)]="type" placeholder="Seleccionar">
            <mat-option value="BUENO">Bueno</mat-option>
            <mat-option value="REGULAR">Regular</mat-option>
            <mat-option value="MALO">Malo</mat-option>
          </mat-select>
        </mat-form-field>
  
        <mat-form-field appearance="legacy" class="col-12 col-md-6">
          <mat-label> Sede</mat-label>
          <mat-select [required]="true" formControlName="sede">
            <mat-option *ngFor="let value of listValues.get('Sede')" [value]="value">
              {{ value.nombre }}
            </mat-option>
          </mat-select>
          <mat-progress-bar class="over-head" mode="indeterminate"
            *ngIf="loadingListValues.get('Sede')"></mat-progress-bar>
        </mat-form-field>
  
        <mat-form-field appearance="legacy" class="col-12 col-md-6">
          <mat-label>Lugar</mat-label>
          <mat-select [required]="true" formControlName="location">
            <mat-option *ngFor="let value of listValues.get('Lugar')" [value]="value">
              {{ value.name }}
            </mat-option>
          </mat-select>
          <mat-progress-bar class="over-head" mode="indeterminate"
            *ngIf="loadingListValues.get('Lugar')"></mat-progress-bar>
        </mat-form-field>
  
        <mat-expansion-panel style="width: 100%">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Bienes Relacionados
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-form-field appearance="legacy" style="width: 100%" *ngFor="let item of movementAssetsForm.get('assets').value">
            <mat-label> Bienes Relacionados </mat-label>
            <input matInput [required]="true" readonly class="pointer" [value]="item">
            <button mat-icon-button matSuffix type="button" color="warn" (click)="removeItems('assets', item)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field appearance="legacy" style="width: 100%">
            <input matInput (click)="selectAssets()" [required]="true" readonly class="pointer" />
            <button mat-icon-button matSuffix type="button" (click)="selectAssets()">
              <mat-icon matTooltip="Agregar">playlist_add</mat-icon>
            </button>
          </mat-form-field>
        </mat-expansion-panel>
         <div class="d-flex justify-content-end py-2">
                <ng-container *ngIf="movementAssetsForm.get('assets').value && movementAssetsForm.get('assets').value.length > 1">
                    <mat-card-title> Total Elementos Seleccionados: {{ movementAssetsForm.get('assets').value.length }}</mat-card-title>
                </ng-container>
            </div>
        <div *ngIf="!block" class="d-flex justify-content-end py-2">
         <button mat-raised-button matTooltip="Cancelar" class="mx-2" (click)="cancel()">
                    Cancelar
          </button>
          <button mat-raised-button [disabled]="movementAssetsForm.invalid" type="button" color="primary" (click)="save(form)">
            <mat-icon>assignment_ind</mat-icon>
              Asignar
          </button>
      </div>
    </form>
    </mat-card-content>
  </mat-card>